<template>
    <nav v-show="menu" class="md:flex md:w-2/5 md:flex-none md:justify-between">
        <template v-for="blok in menu" :key="blok.key">
            <div
                v-for="group in blok.groups"
                :key="group"
                class="mb-12 flex flex-col gap-4 px-4 text-white md:flex-1 md:px-0"
            >
                <div v-for="item in group.items" :key="item">
                    <div v-show="item.type === 'menu_item'">
                        <NuxtLink
                            :to="urlFromStoryblokLinkField(item.link)"
                            class="flex items-center gap-x-2 pr-2"
                        >
                            <span class="underline hover:no-underline">
                                {{ item.link ? item.label : '' }}
                            </span>
                        </NuxtLink>
                    </div>
                    <div v-show="item.type === 'action'">
                        <div
                            class="flex cursor-pointer items-center gap-x-2 pr-2"
                            @click="performAction(item.action)"
                        >
                            <span class="underline hover:no-underline">
                                {{ item.label }}
                            </span>
                        </div>
                    </div>
                    <div v-show="item.type === 'menu_item_header'">
                        <div class="flex items-center gap-x-2">
                            <div class="font-bold uppercase">
                                {{ item.title }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </nav>
</template>

<script setup lang="ts">
import { useCookiebot } from '~/composables/useCookiebot';
import { urlFromStoryblokLinkField } from '~/utils/helpers';

defineProps<{
    menu: Array<any>;
}>();

const { showCookiebotBanner } = useCookiebot();
const performAction = (actionName: string) => {
    switch (actionName) {
        case 'cookie-consent':
            showCookiebotBanner();
            break;
        default:
            break;
    }
};
</script>
